import { render, staticRenderFns } from "./Marketegg.vue?vue&type=template&id=5b89281a&scoped=true&"
import script from "./Marketegg.vue?vue&type=script&lang=js&"
export * from "./Marketegg.vue?vue&type=script&lang=js&"
import style0 from "./Marketegg.vue?vue&type=style&index=0&id=5b89281a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b89281a",
  null
  
)

export default component.exports